import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MOCK_CHATS = [
  {
    id: '1',
    ticket_id: 'HD-24018',
    title: 'Network Team',
    preview: 'HD-24018 ประสบปัญหาการเข้ share log แล้ว ผลวิจารณ์ recon...',
    last_message_time: '03:18',
    last_sender: 'Narin',
    avatar: 'N',
    avatar_color: '#4ade80',
    unread_count: 1,
  },
  {
    id: '2',
    ticket_id: 'HD-24020',
    title: 'Application Support',
    preview: 'ขอ screenshot หน่อย error เริ่มเข้นอินอีกครั้ง . . .',
    last_message_time: '11:28',
    last_sender: 'Mali',
    avatar: 'A',
    avatar_color: '#fb923c',
    unread_count: 1,
  },
  {
    id: '3',
    ticket_id: 'HD-24019',
    title: 'Device Care',
    preview: 'ประสบปัญหาระบบคอมพิวเตอร์ที่จักร-ลาดกว่างสำหรับ...',
    last_message_time: '10:55',
    last_sender: 'Preecha',
    avatar: 'D',
    avatar_color: '#10b981',
    unread_count: 1,
  },
  {
    id: '4',
    ticket_id: 'WAR-001',
    title: 'Shift Supervisor',
    preview: 'จำเป็นต้องยืนยันการแจ้งเตือนระบบเปลี่ยน...',
    last_message_time: '10:17',
    last_sender: 'Aom',
    avatar: 'S',
    avatar_color: '#0ea5e9',
    unread_count: 1,
  },
];

export default function ChatListPage() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredChats, setFilteredChats] = useState(MOCK_CHATS);

  const handleSearch = (value) => {
    setSearchTerm(value);
    const filtered = MOCK_CHATS.filter(
      (chat) =>
        chat.title.toLowerCase().includes(value.toLowerCase()) ||
        chat.ticket_id.toLowerCase().includes(value.toLowerCase()) ||
        chat.preview.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredChats(filtered);
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <h1 style={styles.title}>แชท</h1>
      </header>

      {/* Content */}
      <main style={styles.content}>
        {/* New Chat Button */}
        <button
          onClick={() => navigate('/tickets')}
          style={styles.newChatBtn}
          title="สร้างแชทใหม่"
        >
          + เริ่มต้นใหม่
        </button>

        {/* Search Box */}
        <div style={styles.searchContainer}>
          <input
            type="text"
            placeholder="ค้นหาคำ หรือ Ticket"
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            style={styles.searchInput}
          />
          <span style={styles.searchIcon}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </span>
        </div>

        {/* Chat List */}
        <div style={styles.chatList}>
          {filteredChats.length === 0 ? (
            <div style={styles.emptyState}>
              <p style={styles.emptyIcon}>✉</p>
              <p style={styles.emptyText}>ไม่มีแชท</p>
            </div>
          ) : (
            filteredChats.map((chat) => (
              <div
                key={chat.id}
                onClick={() => navigate(`/chat/${chat.id}`)}
                style={styles.chatItem}
                role="button"
                tabIndex={0}
              >
                {/* Avatar */}
                <div
                  style={{
                    ...styles.avatar,
                    backgroundColor: chat.avatar_color,
                  }}
                >
                  {chat.avatar}
                </div>

                {/* Chat Info */}
                <div style={styles.chatInfo}>
                  <div style={styles.chatHeader}>
                    <h3 style={styles.chatTitle}>{chat.title}</h3>
                    <span style={styles.chatTime}>{chat.last_message_time}</span>
                  </div>
                  <p style={styles.chatTicketId}>{chat.ticket_id}</p>
                  <p style={styles.chatPreview}>{chat.preview}</p>
                </div>

                {/* Right Section */}
                <div style={styles.chatRight}>
                  <div style={styles.senderName}>{chat.last_sender}</div>
                  {chat.unread_count > 0 && (
                    <div style={styles.unreadBadge}>
                      {chat.unread_count}
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </main>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #eef2ff 50%, #f8f7ff 100%)',
    paddingBottom: '64px',
  },

  // Header
  header: {
    background: 'linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.95) 100%)',
    borderBottom: '2px solid rgba(59, 130, 246, 0.1)',
    padding: '1.5rem',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  },
  title: {
    maxWidth: '1200px',
    margin: '0 auto',
    fontSize: '1.75rem',
    fontWeight: '800',
    background: 'linear-gradient(135deg, #1f2937 0%, #1e3a8a 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    color: '#1f2937',
  },

  // Content
  content: {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '1.5rem',
  },

  // New Chat Button
  newChatBtn: {
    width: '100%',
    padding: '0.875rem 1rem',
    background: 'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '1rem',
    fontWeight: '800',
    cursor: 'pointer',
    pointerEvents: 'auto',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 15px rgba(249, 115, 22, 0.3)',
    marginBottom: '1.5rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  'newChatBtn:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 25px rgba(249, 115, 22, 0.4)',
  },
  'newChatBtn:active': {
    transform: 'translateY(0)',
  },

  // Search Box
  searchContainer: {
    position: 'relative',
    marginBottom: '1.5rem',
  },
  searchInput: {
    width: '100%',
    padding: '0.875rem 1rem 0.875rem 2.75rem',
    border: '2px solid rgba(59, 130, 246, 0.2)',
    borderRadius: '12px',
    fontSize: '0.95rem',
    outline: 'none',
    fontFamily: 'inherit',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    pointerEvents: 'auto',
    backgroundColor: '#ffffff',
  },
  'searchInput:focus': {
    borderColor: '#1e3a8a',
    boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.15)',
    backgroundColor: '#ffffff',
  },
  searchIcon: {
    position: 'absolute',
    left: '0.875rem',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '1rem',
    pointerEvents: 'none',
  },

  // Chat List
  chatList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },

  emptyState: {
    textAlign: 'center',
    padding: '3rem 1rem',
  },
  emptyIcon: {
    fontSize: '3rem',
    opacity: 0.3,
    margin: 0,
  },
  emptyText: {
    fontSize: '1rem',
    color: '#94a3b8',
    margin: '1rem 0 0 0',
    fontWeight: '600',
  },

  // Chat Item
  chatItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '1rem',
    background: 'linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.95) 100%)',
    borderRadius: '14px',
    border: '1px solid rgba(59, 130, 246, 0.1)',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    pointerEvents: 'auto',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  },
  'chatItem:hover': {
    transform: 'translateX(8px)',
    boxShadow: '0 8px 24px rgba(59, 130, 246, 0.15)',
    borderColor: 'rgba(59, 130, 246, 0.3)',
    backgroundColor: '#f0f9ff',
  },
  'chatItem:active': {
    transform: 'translateX(4px)',
  },

  // Avatar
  avatar: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    fontWeight: '800',
    fontSize: '1.5rem',
    flexShrink: 0,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },

  // Chat Info
  chatInfo: {
    flex: 1,
    minWidth: 0,
  },
  chatHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: '0.25rem',
    gap: '1rem',
  },
  chatTitle: {
    fontSize: '0.95rem',
    fontWeight: '800',
    color: '#1f2937',
    margin: 0,
    textTransform: 'capitalize',
  },
  chatTime: {
    fontSize: '0.75rem',
    color: '#94a3b8',
    fontWeight: '700',
    flexShrink: 0,
  },
  chatTicketId: {
    fontSize: '0.75rem',
    color: '#64748b',
    fontWeight: '600',
    margin: '0.25rem 0',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  chatPreview: {
    fontSize: '0.825rem',
    color: '#6b7280',
    margin: '0.25rem 0 0 0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: '500',
  },

  // Right Section
  chatRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.5rem',
    flexShrink: 0,
  },
  senderName: {
    fontSize: '0.75rem',
    color: '#64748b',
    fontWeight: '700',
    textTransform: 'capitalize',
  },
  unreadBadge: {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.75rem',
    fontWeight: '700',
    boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
  },
};
